import React from "react"
// import PropTypes from 'prop-types'

import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import queryString from "query-string"
import PYPSidebarItem from "../PYPSidebarItem/PYPSidebarItem"
import colors from "../../Constants/colors"
import Actions from "../../Redux/Actions"
import { gtmClickHandler } from "../../Utils/gtm"
import PYPDownloadContainer from "../PYPDownloadContainer/PYPDownloadContainer"
import {
  buildWorkshopLocation,
  isCourseBuilderWorkshop
} from "../../Utils/workshopNavigation"
import {
  getLastVisitedPartId,
  getOrderedPartIds,
  getSubcoursesForModule,
  isEMpoweredModuleLocked,
  isSubcourseLocked
} from "../../Utils/empoweredProgress"
import { RightArrow } from "../../Icons/RightArrow"

function resolveActiveModuleId(pyp, location) {
  if (!pyp?.modules?.allIds?.length) return null
  const qs = queryString.parse(location?.search || "")
  const urlPartId = qs.partId != null ? Number(qs.partId) : null
  const currentPartId = Number(pyp.navigation?.currentPartId)
  const partId =
    urlPartId > 0
      ? urlPartId
      : currentPartId > 0
        ? currentPartId
        : null

  if (partId) {
    for (const moduleId of pyp.modules.allIds) {
      const ordered = getOrderedPartIds(pyp, moduleId)
      if (ordered.includes(Number(partId))) return moduleId
      const subcourses = getSubcoursesForModule(pyp, moduleId)
      if (
        subcourses.some((s) =>
          (s.partIds || []).map(Number).includes(Number(partId))
        )
      ) {
        return moduleId
      }
    }
  }

  return pyp.navigation?.currentModuleId ?? null
}

export class PYPSidebar extends React.Component {
  constructor(props) {
    super(props)
    this.navItemClickHandler = this.navItemClickHandler.bind(this)
    this.subcourseClickHandler = this.subcourseClickHandler.bind(this)
    this.toggleModule = this.toggleModule.bind(this)
    this.state = {
      expandedModuleId: resolveActiveModuleId(props.pyp, props.location)
    }
  }

  componentDidUpdate(prevProps) {
    if (!isCourseBuilderWorkshop(this.props.pyp)) return
    const prevActive = resolveActiveModuleId(prevProps.pyp, prevProps.location)
    const nextActive = resolveActiveModuleId(
      this.props.pyp,
      this.props.location
    )
    if (
      nextActive != null &&
      Number(prevActive) !== Number(nextActive) &&
      Number(this.state.expandedModuleId) !== Number(nextActive)
    ) {
      this.setState({ expandedModuleId: nextActive })
    }
  }

  toggleModule(moduleId) {
    this.setState((prev) => ({
      expandedModuleId:
        Number(prev.expandedModuleId) === Number(moduleId) ? null : moduleId
    }))
  }

  navItemClickHandler(module) {
    gtmClickHandler({
      name: "SidebarModuleClickEvent",
      data: {
        action: "Sidebar Module Click",
        category: "PYP Engagement",
        label: module.title
      }
    })
  }

  subcourseClickHandler(label) {
    gtmClickHandler({
      name: "SidebarSubcourseClickEvent",
      data: {
        action: "Sidebar Subcourse Click",
        category: "PYP Engagement",
        label
      }
    })
  }

  isModuleLocked(index) {
    const { unlockedUserModules, modules } = this.props.pyp
    const allIds = modules?.allIds || []
    if (index === 0) return false
    const previousModuleId = allIds[index - 1]
    const previousUserModule = unlockedUserModules?.find(
      (um) => um.module_id === previousModuleId
    )
    return !previousUserModule ||
      (previousUserModule.completed !== 1 && previousUserModule.completed !== true)
  }

  getStyle(item, index) {
    const { unlockedUserModules } = this.props.pyp
    if (this.isModuleLocked(index)) {
      return { opacity: 0.5, cursor: "not-allowed" }
    }
    const currentUserModule = unlockedUserModules?.find(
      (um) => um.module_id === item.id
    )
    if (currentUserModule?.completed === 1 || currentUserModule?.completed === true) {
      return { opacity: 0.75, fontWeight: "bold" }
    }
    return undefined
  }

  renderPypModules() {
    return this.props.pyp.modules.allIds.map((moduleId, i) => {
      const item = this.props.pyp.modules.byId[moduleId]
      const isLocked = this.isModuleLocked(i)

      return (
        <PYPSidebarItem
          key={i}
          uniqueKey={i}
          item={item}
          linkTo={buildWorkshopLocation(
            item.title,
            this.props.pyp.navigation
          )}
          textStyle={this.getStyle(item, i)}
          isSelected={
            item.id === this.props.pyp.navigation.currentModuleId
          }
          clickHandler={
            isLocked ? undefined : () => this.navItemClickHandler(item)
          }
        />
      )
    })
  }

  renderEMpoweredSubcourses() {
    const { pyp } = this.props
    const currentPartId = Number(pyp.navigation.currentPartId)
    const qs = queryString.parse(this.props.location.search)
    const urlPartId = qs.partId != null ? Number(qs.partId) : null
    const hasPartSelection =
      (currentPartId > 0 && !Number.isNaN(currentPartId)) ||
      (urlPartId > 0 && !Number.isNaN(urlPartId))
    const pathModule = this.props.match?.params?.module
    const { expandedModuleId } = this.state

    return pyp.modules.allIds.map((moduleId) => {
      const module = pyp.modules.byId[moduleId]
      const moduleLocked = isEMpoweredModuleLocked(pyp, moduleId)
      const subcourses = getSubcoursesForModule(pyp, moduleId)
      const orderedPartIds = getOrderedPartIds(pyp, moduleId)
      const lastVisitedPartId = getLastVisitedPartId(pyp, moduleId)
      const isExpanded = Number(expandedModuleId) === Number(moduleId)
      const isModuleSelected =
        !hasPartSelection &&
        (Number(module.id) === Number(pyp.navigation.currentModuleId) ||
          pathModule === module.title)

      return (
        <div key={moduleId} style={styles.moduleSection}>
          <div
            role="button"
            tabIndex={0}
            onClick={() => this.toggleModule(moduleId)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                this.toggleModule(moduleId)
              }
            }}
            style={{
              ...styles.moduleHeader,
              ...(moduleLocked ? styles.moduleHeaderLocked : {}),
              ...(isModuleSelected ? styles.moduleHeaderSelected : {})
            }}
          >
            <span style={styles.moduleHeaderTitle}>{module.title}</span>
            <span style={styles.moduleChevron}>
              <span
                style={{
                  display: "flex",
                  transform: isExpanded ? "rotate(90deg)" : "none"
                }}
              >
                <RightArrow
                  width="12"
                  height="18"
                  stroke="#FFF"
                  strokeWidth="2"
                />
              </span>
            </span>
          </div>
          {isExpanded &&
            subcourses.map((subcourse, j) => {
              const partIds = (subcourse.partIds || []).map(Number)
              const subLocked = isSubcourseLocked({
                orderedPartIds,
                subcourse,
                subcourseIndex: j,
                lastVisitedPartId,
                moduleLocked
              })
              const itemLocked = moduleLocked || subLocked
              const isSelected =
                (currentPartId > 0 && partIds.includes(currentPartId)) ||
                (urlPartId > 0 && partIds.includes(urlPartId))
              const linkTo = buildWorkshopLocation(
                module.title,
                pyp.navigation,
                "/content",
                subcourse.firstPartId
              )

              return (
                <PYPSidebarItem
                  key={`${moduleId}-${subcourse.firstPartId}-${j}`}
                  uniqueKey={`${moduleId}-${j}`}
                  item={{ title: subcourse.label }}
                  linkTo={itemLocked ? undefined : linkTo}
                  textStyle={{
                    ...styles.subcourseTitle,
                    ...(itemLocked
                      ? { opacity: 0.5, cursor: "not-allowed" }
                      : undefined)
                  }}
                  isSelected={isSelected}
                  wrapText
                  indent
                  clickHandler={
                    itemLocked
                      ? (e) => {
                          if (e && e.preventDefault) e.preventDefault()
                        }
                      : () => this.subcourseClickHandler(subcourse.label)
                  }
                />
              )
            })}
        </div>
      )
    })
  }

  render() {
    const isCourseBuilder = isCourseBuilderWorkshop(this.props.pyp)

    return (
      <div
        style={{
          ...styles.sidebarContainer,
          ...(isCourseBuilder ? styles.sidebarContainerEMpowered : {})
        }}
        className="sidebarContainer"
      >
        <div
          style={{
            ...styles.sidebarContent,
            ...(isCourseBuilder ? styles.sidebarContentEMpowered : {})
          }}
          className="sidebarContent"
        >
          <div style={styles.sidebarHeader}>
            <div
              style={{
                ...styles.headerTitle,
                ...(isCourseBuilder ? styles.headerTitleWrap : {})
              }}
            >
              {this.props.pyp.navigation.currentCourseName ||
                "Pursue Your Purpose"}
            </div>
            <div style={{ height: "20px" }} />
            <div style={styles.horizontalBar} />
            <div style={{ height: "20px" }} />
          </div>

          <div
            style={{
              ...styles.sidebarItemsContainer,
              ...(isCourseBuilder
                ? styles.sidebarItemsContainerWrap
                : styles.sidebarItemsContainerPyp)
            }}
          >
            {isCourseBuilder
              ? this.renderEMpoweredSubcourses()
              : this.renderPypModules()}
          </div>
        </div>

        <div
          style={styles.sideBarSectionFixedBottom}
          className="sidebarLowerSection"
        >
          <PYPDownloadContainer />
        </div>
      </div>
    )
  }
}

const styles = {
  sidebarContainer: {
    display: "flex",
    width: "100%",
    height: "100%",
    minHeight: "calc(100vh - 60px)",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingRight: "15px",
    zIndex: 2
  },
  sidebarContainerEMpowered: {
    minHeight: 0,
    maxHeight: "100%",
    overflow: "hidden"
  },
  sidebarContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "flex-start",
    minHeight: "65px"
  },
  sidebarContentEMpowered: {
    minHeight: 0
  },
  sidebarHeader: {
    minHeight: "100px",
    paddingTop: "50px",
    paddingLeft: "30px"
  },
  headerTitle: {
    fontFamily: "Lato-Bold",
    fontSize: "20px",
    whiteSpace: "nowrap",
    lineHeight: "42px",
    color: colors.white
  },
  headerTitleWrap: {
    whiteSpace: "normal",
    overflowWrap: "break-word",
    paddingRight: "15px"
  },
  horizontalBar: {
    width: "100%",
    borderBottom: `solid 1px ${colors.mediumBlue}`
  },
  sidebarItemsContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "0px",
    minHeight: 0 /* for Firefox */
  },
  sidebarItemsContainerPyp: {
    overflow: "auto"
  },
  sidebarItemsContainerWrap: {
    overflowY: "auto",
    overflowX: "hidden",
    paddingBottom: "16px"
  },
  moduleSection: {
    marginBottom: "12px"
  },
  moduleHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    fontFamily: "Lato-Bold",
    fontSize: "16px",
    lineHeight: "20px",
    color: colors.white,
    opacity: 0.85,
    padding: "8px 15px 4px 30px",
    textTransform: "none",
    cursor: "pointer",
    userSelect: "none"
  },
  moduleHeaderTitle: {
    flex: 1,
    minWidth: 0
  },
  moduleChevron: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "20px",
    marginLeft: "8px"
  },
  moduleHeaderLocked: {
    opacity: 0.45
  },
  moduleHeaderSelected: {
    borderLeft: `solid 4px ${colors.fadedRed}`,
    opacity: 1,
    paddingLeft: "26px"
  },
  subcourseTitle: {
    paddingLeft: "50px"
  },
  sideBarSectionFixedBottom: {
    width: "calc(100% + 15px)"
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    pyp: state.pyp
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PYPSidebar)
)
